<template>
  <div class="video-recorder-error" data-test-id="VideoRecorderError">
    <slot />
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {},
})
</script>
<style lang="postcss">
.video-recorder-error {
  z-index: 1;
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 30vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  border-radius: 0.5rem;
  aspect-ratio: 4 / 3;
  background-color: #464646;
  color: white;
  text-align: center;

  a {
    color: mediumaquamarine;
  }

  > img {
    margin-bottom: 1rem;
  }
}
</style>
